/* ────────────────────────────────────────────────────────────────────────
   Phase 2 (CLAUDE-THEMES.md) -- sitewide behaviors ported out of
   assets/custom.js, which exists in this theme but is never enqueued
   anywhere (same orphaned-file pattern as assets/custom.css and
   assets/responsive.css -- see CL-045/046). jQuery already loaded
   synchronously since Phase 1 subtask 3 (CL-035). Only the still-relevant
   behaviors below were ported -- the rest of custom.js was audited and
   confirmed dead (Swiper instantiations superseded by the Dawn-native
   slider rebuilds, the tag-based filter system inert, etc.) -- see
   CLAUDE-THEMES.md Phase 2 for the full classification. */

$(document).ready(function () {

  /* Desktop nav dropdown opens on hover, not just click/tap. Uses
     CONTROL's original .header__inline-menu selector unchanged --
     CORRECTED 2026-07-15 (conditional-logic smell test): this class was
     never actually renamed. It still wraps the whole nav in
     snippets/header-dropdown-menu.liquid (<nav class="header__inline-menu">),
     just nested one level deeper than expected. The custom.js audit
     (CL-049) checked header.liquid but not this snippet, wrongly concluded
     the class was gone, and substituted .list-menu--inline instead --
     which reaches the same <details> elements and worked, but deviated
     from CONTROL for no reason. Switched back to match CONTROL exactly. */
  var navMenu = document.querySelector('.header__inline-menu');
  if (navMenu) {
    var items = navMenu.querySelectorAll('details');
    items.forEach(function (item) {
      item.addEventListener('mouseover', function () {
        item.setAttribute('open', true);
        item.querySelector('ul').addEventListener('mouseleave', function () {
          item.removeAttribute('open');
        });
        item.addEventListener('mouseleave', function () {
          item.removeAttribute('open');
        });
      });
    });
  }

  /* Relocates the Back In Stock app's product-page trigger button into
     its landing div (restored in sections/main-product.liquid). The app
     renders #BIS_trigger itself; this just moves it into position, same
     as CONTROL. No-ops harmlessly on pages without the landing div. */
  setTimeout(function () {
    $('#BIS_trigger').detach().appendTo('.Email_sms_button');
  }, 1200);

  /* Product-page gallery: show only images matching the selected color
     variant, hide the rest. thumbnail-color/image_alt attributes restored
     onto snippets/product-media-gallery.liquid's <li> elements (sourced
     from each image's alt text, same convention CONTROL used). This is
     additive to Dawn's own native variant-media sync (product-info.js
     updateMedia(), which only scrolls to the variant's featured media --
     it never hides the others), not a replacement for it. */
  $('.product-form__input input[type=radio]').on('click', function () {
    var selectedVariant = $(this).val();
    var imageAltEnabled = $('.product__media-list li').attr('image_alt');
    if (imageAltEnabled == 'enabled') {
      $('.product__media-item').each(function () {
        var thumbnailColor = $(this).attr('thumbnail-color');
        if (thumbnailColor === selectedVariant) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }
  });

  /* Same filtering, applied on initial page load when arriving via a
     ?variant= URL (e.g. a color-swatch link from a collection page) --
     CONTROL ran this on load in addition to the click handler above. */
  var searchParams = new URLSearchParams(window.location.search);
  var paramVariant = searchParams.get('variant');
  if (paramVariant) {
    var checkedVariant = $('.product-form__input input[type=radio]:checked').val();
    var imageAltEnabled = $('.product__media-list li').attr('image_alt');
    if (imageAltEnabled == 'enabled') {
      $('.product__media-item').each(function () {
        var thumbnailColor = $(this).attr('thumbnail-color');
        if (thumbnailColor === checkedVariant) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }
  }

});
